// extracted by css-extract-rspack-plugin
export default {"cls1":"step_two-cls1_uj4","cls2":"step_two-cls2_bvE step_two-cls1_uj4"};